import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext } from 'react';
import { Box, Center, Grid } from '@chakra-ui/react';
import { RFNodeIcon } from '../../base';
import { useNodeTemplate } from '../../../hooks';
import { GREY_HEX, GRID_HEX } from '../../../constants';
import { RFConfigContext } from '../../../contexts';
import { MULTI_STEP_EXTERNAL_CONFIG } from './RFMultiStepExternalNode.config';
/** Синтетический элемент **/
/**
 * Component renders "multiStepExternal" type of node of ReactFlow.
 * @param props : props come from ReactFlow.
 * See RF_NODE_TYPES.
 */
const RFMultiStepExternalNodeFC = ({ id, data, type, selected, isConnectable = true }) => {
    const { isInspector } = useContext(RFConfigContext) ?? {};
    const { isValidTemplate, renderPorts, renderError } = useNodeTemplate({
        id,
        selected,
        templateCode: data.templateCode,
        config: MULTI_STEP_EXTERNAL_CONFIG
    });
    return isValidTemplate ? (_jsxs(_Fragment, { children: [_jsxs(Grid, { "data-templateid": data.templateCode, templateRows: "auto auto", gap: "4px", children: [_jsx(RFNodeIcon, { id: id, padding: "8px", rfType: type, isSelected: selected, isInspector: isInspector, templateCode: data.templateCode ?? '', children: _jsxs(Center, { width: "56px", height: "56px", bg: GRID_HEX, borderRadius: "4px", lineHeight: '10px', border: "1px solid", borderColor: GREY_HEX, flexDirection: 'column', children: [_jsx(Box, { fontSize: '9px', children: "\u0421\u0438\u043D\u0442\u0435\u0442\u0438\u0447." }), _jsx(Box, { fontSize: '9px', children: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442" })] }) }), _jsx(Box, { p: "0 4px", w: "72px", textAlign: "center", fontSize: "12px", lineHeight: "14px", fontWeight: 700, className: "cut-text", children: data.title })] }), renderPorts(isConnectable, isInspector)] })) : (_jsx(_Fragment, { children: renderError() }));
};
export const RFMultiStepExternalNode = RFMultiStepExternalNodeFC;
//# sourceMappingURL=RFMultiStepExternalNode.js.map